window.getCookie = (name) => {
  const match = document.cookie.match(new RegExp(`(^| )${name}=([^;]+)`));
  if (match) return match[2];
};

window.setCookie = (name, value, days = 30) => {
  let expires = "";
  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = `expires=${date.toUTCString()};`;
  }

  const path = "path=/;";
  const domain = `Domain=${getRootDomain()};`;

  document.cookie = `${name}=${value || ""};${expires}${path}${domain}`;
};

const parseGid = (gid) => {
  if (gid.startsWith("gid://shopify/" || gid !== Number)) {
    const match = gid.match(/gid:\/\/shopify\/[^/]+\/([a-f0-9-]+)/);
    if (match) return match[1];
  }
  return gid;
};

/**
 * Safely escape a single quote for use in JSON payloads
 *
 * Ex: "D'Amour" -> "D\'Amour"
 *
 * @param {string} string - string.
 * @returns {string} safelyEscapedString - A new string with the single quote escaped.
 */
const escapeSingleQuote = (string) => {
  const safelyEscapedString = string.replace("'", `\'`);

  return safelyEscapedString;
};

const gtag = (data) => {
  try {
    const userData = getUserData();
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      ...data,
      customer: {
        ...userData,
        ...data.customer,
      },
    });
  } catch (error) {
    console.error("gtag error", error);
  }
};

const returnCat2 = (type) => {
  if (type === "Bridesmaid Dress") {
    return "Bridesmaid Dresses";
  }
  if (type === "Swatch") {
    return "Swatches";
  }
  if (type === "Groomsmen Accessory" || type === "Groomsmen Suiting") {
    return "Groomsmen";
  }
  if (
    type === "Party Stuff" ||
    type === "Apparel" ||
    type === "Swag" ||
    type === "Getting Ready" ||
    type === "Face Mask" ||
    type === "Jewelry" ||
    type === "Shoes" ||
    type === "Seamless Underwear" ||
    type === "Gifts" ||
    type === "Complete the Look" ||
    type === "Hair Accessories"
  ) {
    return "NDC";
  }
  if (type === "Gift Card") {
    return "Gift Cards";
  }
  return "Other";
};

const fabricMap = {
  chiffon: "Chiffon",
  tulle: "Tulle",
  mesh: "Mesh",
  satin: "Satin",
  crepe: "Crepe",
  knit: "Knit",
};

const returnCat3 = ({ type, tags }) => {
  function getMaterialLabel(productType, productTags) {
    const fabric = productTags.find((tag) => tag.includes(fabricMap[tag]));
    return fabric
      ? `${fabric} ${productType}`
      : `${productType} of Indeterminate Material`;
  }
  if (type === "Bridesmaid Dress" || type === "Swatch") {
    getMaterialLabel(type, tags);
  }
  if (type === "Groomsmen Accessory") {
    return "Groomsmen Accessories";
  }
  if (type === "Groomsmen Suiting") {
    return "Groomsmen Suiting";
  }
  if (type === "Party Stuff" || type === "Apparel" || type === "Swag") {
    return "Party";
  }
  if (type === "Getting Ready") {
    return "Getting Ready";
  }
  if (
    type === "Face Mask" ||
    type === "Jewelry" ||
    type === "Shoes" ||
    type === "Seamless Underwear" ||
    type === "Hair Accessories"
  ) {
    return "Complete the Look";
  }
  if (type === "Gifts") {
    return "Gifts";
  }
  if (type === "Gift Card") {
    return "Gift Cards";
  }
  return "Other";
};

const returnCat4 = ({ type, title, tags }) => {
  function getFabricAndColor(productType, productTags, productTitle) {
    const fabric =
      productTags.find((tag) => tag.includes(fabricMap[tag])) ||
      "Indeterminate Material";
    const newTitleParts = productTitle.split("-");
    const color =
      newTitleParts.length > 1
        ? newTitleParts[1].replace(fabric, "").replace("in", "").trim()
        : "Indeterminate Color";
    return `${color} ${productType}`;
  }

  if (type === "Bridesmaid Dresses" || type === "Swatch") {
    getFabricAndColor(type, tags, title);
  }

  if (type === "Groomsmen Accessory") {
    if (tags.includes("Bow Tie")) {
      return "Bow Ties";
    }
    if (tags.includes("Pocket Square")) {
      return "Pocket Squares";
    }
    if (tags.includes("Necktie")) {
      return "Neck Ties";
    }
    return "Indeterminate Groomsmen Accessories";
  }
  if (type === "Groomsmen Suiting") {
    return "Groomsmen Suiting";
  }
  if (type === "Party Stuff" || type === "Apparel" || type === "Swag") {
    return type;
  }
  if (type === "Getting Ready") {
    if (tags.includes("Robes")) {
      return "Robes";
    }
    if (tags.includes("Pajamas")) {
      return "Pajamas";
    }
    if (
      tags.includes("Slippers") ||
      tags.includes("Socks") ||
      tags.includes("Sleep Masks")
    ) {
      return "Getting Ready Accessories";
    }
    return "Indeterminate Getting Ready";
  }
  if (
    type === "Face Mask" ||
    type === "Jewelry" ||
    type === "Shoes" ||
    type === "Seamless Underwear" ||
    type === "Hair Accessories"
  ) {
    return type;
  }
  if (type === "Gifts") {
    return "Gifts";
  }
  if (type === "Gift Card") {
    return "Gift Cards";
  }
  return "Other";
};

const getAttributionData = () => {
  const data = {};
  const storageToAttribution = {
    iT: "initial_timestamp",
    iS: "initial_source",
    iM: "initial_medium",
    iC: "initial_campaign",
    iCo: "initial_content",
    vT: "visit_timestamp",
    vS: "visit_source",
    vM: "visit_medium",
    vC: "visit_campaign",
    vCo: "visit_content",
  };
  Object.keys(storageToAttribution).forEach((key) => {
    if (localStorage[key]) {
      data[storageToAttribution[key]] = localStorage[key];
    }
  });

  return data;
};

const getLineItemShippingState = (lineItem) => {
  let shippingState = "";
  const props = lineItem?.properties || {};
  if ("_READY-TO-SHIP" in props || "_QUICK_SWATCH" in props) {
    shippingState = "RTS";
  } else if ("_MADE-TO-ORDER" in props) {
    shippingState = "MTO";
  } else if ("_PREORDER" in props) {
    shippingState = "PREORDER";
  }
  return shippingState;
};

const getEventId = () => Math.floor(Math.random() * 1000000000).toString();

const getUserData = () => JSON.parse(getCookie("bg_user_data") || "{}");

/**
 * The product image's source often comes back as "//cdn.shopify.com..."
 *
 * Here we test the URL and append a HTTPS: protocol if it doesn't have it.
 */
const processImageUrl = (productImageURL) => {
  let processedImageUrl = productImageURL;
  if (!/^https?:\/\//.test(productImageURL)) {
    processedImageUrl = `https:${
      productImageURL.startsWith("//")
        ? productImageURL
        : `//${productImageURL}`
    }`;
  }

  return processedImageUrl;
};

const setUserData = (data = {}) => {
  const existingData = getUserData();
  const updatedData = { ...existingData, ...data };
  window.setCookie("bg_user_data", JSON.stringify(updatedData));
  return null;
};
const getProductReviews = () => {
  const reviewCount = parseInt(window.updateReviewCount().reviewCount, 10);
  const reviewRating = parseFloat(window.updateReviewCount().ratingValue);
  return {
    reviewCount: reviewCount || 0,
    reviewRating: reviewRating || null,
  };
};

const getVideosCount = () => {
  const videos = document.querySelectorAll(".product-video-thumb").length || 0;
  return videos;
};
const getSsProductIds = (crossSell) => {
  const ssEvents = window.searchspring.controller[crossSell].events;
  const productIds = ssEvents.product;
  return Object.keys(productIds) || [];
};
const getRushFeePrice = () => {
  const fee = document.querySelector("[data-rush-fee]")?.dataset.rushFee;
  return parseFloat(fee?.replace("$", "")) || 0;
};

const getColorPosition = () => {
  const variantSelectorColors = document.querySelector(
    "variant-colors input:checked",
  );
  const variantSelectorColorsIndex = variantSelectorColors.dataset.index;
  return variantSelectorColorsIndex || 0;
};

const getBarColors = (page = null) => {
  const colors = [];
  if (page === "homepage") {
    const homepageColors = document.querySelectorAll(
      ".swatch-lp-color-bar-b #color-carousel a[href]",
    );
    homepageColors.forEach((el) => {
      const color = el.getAttribute("data-color");
      colors.push(color);
    });
    return colors;
  }
  document
    .querySelectorAll('.filter-swatch[href*="filter:tags_color_bar"]')
    .forEach((el) => {
      const href = el.getAttribute("href");
      const matches = href.match(/filter:tags_color_bar:([a-zA-Z0-9$%]+)/g);
      if (matches) {
        matches.forEach((match) => {
          const rawColor = match.split(":").pop();
          const decodedColor = decodeURIComponent(
            rawColor.replace(/\$2520/g, "%20"),
          );
          if (!colors.includes(decodedColor)) {
            colors.push(decodedColor);
          }
        });
      }
    });
  return colors;
};

const getMoreToLove = () => {
  const moreToLove = [];
  const section = document.querySelector("[data-section-title='more-to-love']");
  if (!section) return;
  const items = section.querySelectorAll("[data-collection-id]");
  items.forEach((el) => {
    const collectionId = el.getAttribute("data-collection-id");
    moreToLove.push(collectionId);
  });
  return moreToLove;
};

const getFeaturedDresses = () => {
  const featuredDresses = [];
  const section = document.querySelector("#best-seller-panel");
  if (!section) return;
  const items = section.querySelectorAll(".featured-product-grid-item");
  items.forEach((el) => {
    const productId = el.getAttribute("data-product-id");
    featuredDresses.push(productId);
  });
  return featuredDresses;
};

const getActualPrice = () => {
  const priceText = document.querySelector("#product-price").textContent.trim();
  const numericValue = parseFloat(priceText.replace(/[^0-9.]/g, ""));
  return isNaN(numericValue) ? null : numericValue;
};

const getProductionAvailability = (inventoryList, rushFee) => {
  if (!Array.isArray(inventoryList)) return {};

  const getEnabled = (item) =>
    item?.inventory > 0 || item?.inventory_policy === "continue";

  const mtoItem = inventoryList.find(
    (v) => v.shipping_details === "Standard Production",
  );
  const rtsItem = inventoryList.find(
    (v) => v.shipping_details === "Rush Production",
  );

  const mtoEnabled = getEnabled(mtoItem) && rushFee > 0;
  const rtsEnabled = getEnabled(rtsItem);

  return {
    mto_enabled: mtoEnabled,
    rts_enabled: rtsEnabled,
  };
};

const getFabric = () => {
  const fabricLegend = document.querySelector(
    ".product-wrapper #fabric-legend",
  );
  return fabricLegend?.textContent.trim() || "";
};

function getStyle(name) {
  const fullStyle = name.split("-")[0].trim();
  return fullStyle.split(" ")[0];
}

const trackNavigationClick = (type, page, link, image) => {
  if (["nav_click", "sub_nav_click"].includes(type)) {
    gtag({
      event: type,
      eventID: getEventId(),
      eventData: {
        destinationPage: page,
        destinationURL: link,
      },
    });
  } else {
    gtag({
      event: "sub_nav_feature_click",
      eventID: getEventId(),
      eventData: {
        image: processImageUrl(image),
        ctaText: page,
        ctaURL: link,
      },
    });
  }
};

const trackAddToCart = (lineItem, cart, klaviyoProduct = null) => {
  if (!lineItem) {
    console.error("trackAddToCart, lineItem is required");
    return false;
  }

  const shippingState = getLineItemShippingState(lineItem);

  const isStorefrontCart = window.features?.storefront_api_enabled;

  gtag({ ecommerce: null, klaviyo_cart: null, klaviyo_product: null });
  gtag({
    event: "add_to_cart",
    eventID: getEventId(),
    ecommerce: {
      currency: "USD",
      cart_type: isStorefrontCart ? "storefront" : "ajax",
      cart_total: cart.total_price / 100,
      value: lineItem.line_price / 100,
      items: [
        {
          item_id: isStorefrontCart
            ? parseGid(lineItem.product_id)
            : lineItem.product_id,
          variant_id: isStorefrontCart
            ? parseGid(lineItem.variant_id)
            : lineItem.variant_id,
          item_variant: isStorefrontCart
            ? parseGid(lineItem.variant_id)
            : lineItem.variant_id,
          item_name: lineItem.product_title,
          item_options: lineItem.variant_title,
          item_image: lineItem.image,
          item_url: `${window.location.hostname}${lineItem.url}`,
          sku: lineItem.sku,
          item_brand: lineItem.vendor,
          item_category: lineItem.product_type,
          item_category2: returnCat2(lineItem.product_type),
          price: lineItem.price / 100,
          compare_at_price: lineItem.original_price / 100,
          quantity: lineItem.quantity,
          shipping_state: shippingState,
        },
      ],
    },
    klaviyo_cart: {
      total_price: cart.total_price / 100,
      $value: cart.total_price / 100,
      total_discount: cart.total_discount,
      original_total_price: cart.original_total_price / 100,
      items: cart.items,
      AddedItemCategories: Array.from(
        new Set(cart.items.map((item) => item.product_type)),
      ).join(", "),
    },
    klaviyo_product: klaviyoProduct,
  });
  return null;
};

const trackAddToWaitlist = (product, variant, email) => {
  if (!product || !variant) {
    console.error("trackAddToWaitlist, product and variant are required");
    return false;
  }

  gtag({ ecommerce: null, klaviyo_cart: null, klaviyo_product: null });
  gtag({
    event: "waitlist_signup",
    eventID: getEventId(),
    ecommerce: {
      currency: "USD",
      value: variant.price / 100 || "",
      pageType: "product",
      items: [
        {
          item_id: product.id,
          variant_id: variant.id,
          item_variant: variant.id,
          item_name: variant.title,
          item_options: variant.title,
          sku: variant.sku,
          item_brand: product.vendor,
          item_category: product.type,
          item_category2: returnCat2(product.type),
          price: variant.price / 100 || "",
        },
      ],
    },
    customer: {
      email,
    },
  });
  trackIdentify(email, {
    klaviyo_identify: {
      $email: email,
    },
  });
  return null;
};

const trackProductView = (product, variant) => {
  if (!product) {
    console.error("trackProductView, product is required");
    return false;
  }

  /**
   * The product image's source often comes back as "//cdn.shopify.com..."
   *
   * Here we test the URL and append a HTTPS: protocol if it doesn't have it.
   */
  let productImageURL = product.images[0]?.src || product.images[0];
  productImageURL = processImageUrl(productImageURL);

  const currentVariantInventory = window.productInventory?.filter(
    (productVariant) => productVariant.size === variant.option1,
  );

  const inventoryDetails = variant.option3
    ? {
        MTO_inventory:
          currentVariantInventory.find(
            (v) => v.shipping_details === "Standard Production",
          )?.inventory || 0,
        RTS_inventory:
          currentVariantInventory.find(
            (v) => v.shipping_details === "Rush Production",
          )?.inventory || 0,
      }
    : {
        RTS_inventory: currentVariantInventory[0]?.inventory || 0,
      };

  const productionAvailability = getProductionAvailability(
    currentVariantInventory,
    getRushFeePrice(),
  );
  gtag({ ecommerce: null, klaviyo_product: null });
  gtag({
    event: "view_content",
    eventID: getEventId(),
    pageType: "product",
    ecommerce: {
      currency: "USD",
      value: product.price / 100,
      items: [
        {
          item_id: product.id,
          variant_id: variant?.id,
          item_variant: variant?.id,
          item_name: escapeSingleQuote(product.title),
          sku: variant?.sku,
          item_brand: product.vendor,
          item_category: product.type,
          item_category2: returnCat2(product.type),
          item_category3: returnCat3(product),
          item_category4: returnCat4(product),
          price: product.price / 100,
          compare_at_price: product.compare_at_price
            ? product.compare_at_price / 100
            : null,
          actual_price: getActualPrice()
            ? getActualPrice()
            : product.price / 100,
          inventory_details: inventoryDetails,
          production_availability: productionAvailability,
          style: getStyle(variant.name),
          color: variant.option2,
          fabric: getFabric(),
          rush_fee_amount: getRushFeePrice(),
        },
      ],
    },
    klaviyo_product: {
      Name: product.title,
      ProductID: product.id,
      ImageURL: productImageURL,
      URL: `https://www.birdygrey.com/products/${product.handle}`,
      Brand: product.vendor.replace("'", ""),
      Price: product.price / 100,
      CompareAtPrice:
        product.compare_at_price === null ? 0 : product.compare_at_price / 100,
      ProductImages: product.images,
    },
  });
  gtag({
    event: "view_content_enriched",
    eventID: getEventId(),
    pageType: "product",
    ecommerce: {
      currency: "USD",
      value: product.price / 100,
      items: [
        {
          item_id: product.id,
          variant_id: variant?.id,
          item_variant: variant?.id,
          item_name: escapeSingleQuote(product.title),
          sku: variant?.sku,
          item_brand: product.vendor,
          item_category: product.type,
          item_category2: returnCat2(product.type),
          item_category3: returnCat3(product),
          item_category4: returnCat4(product),
          price: product.price / 100,
          compoare_at_price: product.compare_at_price
            ? product.compare_at_price / 100
            : null,
          inventory_details: inventoryDetails,
          rush_fee_price: getRushFeePrice(),
          color_position: getColorPosition(),
          number_of_images: product.images?.length || 0,
          number_of_videos: getVideosCount(),
          reviews_count: getProductReviews().reviewCount,
          reviews_rating: getProductReviews().reviewRating,
          yaml_items: getSsProductIds("recommend_similar_0"),
          clt_items: getSsProductIds("recommend_cross-sell_0"),
          recently_viewed_items: getSsProductIds("recommend_recently-viewed_0"),
        },
      ],
    },
    klaviyo_product: {
      Name: product.title,
      ProductID: product.id,
      ImageURL: productImageURL,
      URL: `https://www.birdygrey.com/products/${product.handle}`,
      Brand: product.vendor.replace("'", ""),
      Price: product.price / 100,
      CompareAtPrice:
        product.compare_at_price === null ? 0 : product.compare_at_price / 100,
      ProductImages: product.images,
    },
  });
  return null;
};

const trackCollectionView = (products, totalProducts, selectedSort) => {
  if (!products || !Array.isArray(products)) {
    console.error("trackCollectionView, product is required");
    return false;
  }

  const shipsNowProducts = document.querySelectorAll(
    ".selling-fast:not(.none)",
  );
  const ssInlineBanners = document.querySelectorAll(
    ".ss__result--inline-banner",
  );
  const allproducts = document.querySelectorAll(".ss__result");
  const inlinePositions = [];

  allproducts.forEach(
    (product, key) =>
      product.classList.value.includes("ss__result--inline-banner") &&
      inlinePositions.push(key),
  );

  const items = products.map((product) => ({
    item_id: product.id,
    variant_id: product.variant_id,
    item_variant: product.variant_id,
    item_name: product.title,
    item_category: product.type,
  }));

  gtag({ ecommerce: null });
  gtag({
    event: "view_item_list",
    eventID: getEventId(),
    pageType: "collection",
    ships_now_product_count: shipsNowProducts?.length / 2 || 0,
    inline_ss_banners_count: ssInlineBanners?.length || 0,
    inline_ss_banners_positions: inlinePositions,
    product_sort_order: selectedSort,
    product_count: totalProducts || products.length || 0,
    color_bar_order: getBarColors() || [],
    ecommerce: {
      currency: "USD",
      items,
    },
  });
  return null;
};

const trackCartView = (value, lineItems) => {
  const isStorefrontCart = window.features?.storefront_api_enabled;
  const items = lineItems.map((line, index) => ({
    item_id: isStorefrontCart ? parseGid(line.product_id) : line.product_id,
    variant_id: isStorefrontCart ? parseGid(line.variant_id) : line.variant_id,
    item_variant: isStorefrontCart
      ? parseGid(line.variant_id)
      : line.variant_id,
    item_name: line.title,
    sku: line.sku,
    index,
    item_brand: line.vendor,
    item_category: line.product_type,
    price: line.price / 100,
    quantity: line.quantity,
    shipping_state: getLineItemShippingState(line),
  }));
  gtag({ ecommerce: null });
  gtag({
    event: "view_cart",
    eventID: getEventId(),
    pageType: "cart",
    ecommerce: {
      currency: "USD",
      value,
      cart_type: isStorefrontCart ? "storefront" : "ajax",
      items,
    },
  });
  return null;
};

const trackIdentify = (email, data = {}) => {
  if (!email) {
    console.error("trackIdentify, email is required");
    return false;
  }
  gtag({
    event: "identify",
    customer: {
      email,
    },
    ...data,
  });
  setUserData({
    email,
  });
  return null;
};

const trackLead = (email, data = {}) => {
  const { hostname } = window.location;
  if (!email) {
    console.error("trackLead, email is required");
    return false;
  }

  const eventData = {
    customer: {
      email,
    },
    signup_location: data.signup_location,
    lead: {
      location: data.signup_location,
      brand: "Birdy Grey",
      source: hostname.replace("www.", ""),
      listId: data.list_id,
    },
    ...getAttributionData(),
  };

  gtag({
    event: "lead",
    ...eventData,
  });

  trackIdentify(email, {
    klaviyo_identify: {
      $email: email,
    },
  });
  return null;
};

const trackColorBarScroll = (direction) => {
  gtag({
    event: "colorbar_scroll",
    eventID: getEventId(),
    eventData: {
      direction,
    },
  });
};

const trackMiniCartClick = (state) => {
  gtag({
    event: "mini_cart_click",
    eventData: {
      state,
    },
  });
};

const trackMiniCartView = (value, lineItems, pageType, upsells) => {
  if (!lineItems) {
    gtag({
      event: "view_mini_cart",
      eventID: getEventId(),
      pageType,
      ecommerce: {
        currency: "USD",
        value: 0,
      },
    });
    return;
  }
  const isStorefrontCart = window.features?.storefront_api_enabled;

  const items = lineItems.map((line, index) => ({
    item_id: isStorefrontCart ? parseGid(line.product_id) : line.product_id,
    variant_id: isStorefrontCart ? parseGid(line.variant_id) : line.variant_id,
    item_variant: isStorefrontCart
      ? parseGid(line.variant_id)
      : line.variant_id,
    item_name: line.title,
    sku: line.sku,
    index,
    item_brand: line.vendor,
    item_category: line.product_type,
    price: line.price / 100,
    quantity: line.quantity,
    shipping_state: getLineItemShippingState(line),
  }));
  gtag({ ecommerce: null });
  gtag({
    event: "view_mini_cart",
    eventID: getEventId(),
    pageType: pageType,
    ecommerce: {
      currency: "USD",
      value,
      cart_type: isStorefrontCart ? "storefront" : "ajax",
      items,
    },
    eventData: {
      upsells,
    },
  });
  return null;
};

const publishEventToShopify = (eventName, eventData) => {
  if (!eventName || !eventData) {
    console.error("publishEventToShopify, eventData or eventName is missing");
    return false;
  }
  if (!window.Shopify || !window.Shopify.analytics) {
    console.error("publishEventToShopify, Shopify.analytics is not available");
    return false;
  }
  try {
    const userData = getUserData();
    window.Shopify.analytics.publish(eventName, {
      ...eventData,
      customer: {
        ...userData,
      },
    });
  } catch (error) {
    console.error(`publishEventToShopify, error for ${eventName}`, error);
  }
  return null;
};

const trackHomepageView = () => {
  gtag({
    event: "homepage_view",
    eventID: getEventId(),
    eventData: {
      color_bar_order: getBarColors("homepage") || [],
      more_to_love_order: getMoreToLove() || [],
      featured_dresses: getFeaturedDresses() || [],
    },
  });
};

const trackMoreToLoveClick = () => {
  const section = document.querySelector("[data-section-title='more-to-love']");
  const collections = section.querySelectorAll("[data-collection-id]");
  collections.forEach((collection) => {
    collection.querySelector("a").addEventListener("click", () => {
      const item_id = collection.getAttribute("data-collection-id");
      const item_title = collection.getAttribute("data-collection-title");
      const item_featured_image = collection.getAttribute(
        "data-collection-image",
      );
      const item_url = collection.getAttribute("data-collection-url");
      const item = {
        item_id,
        item_title,
        item_featured_image,
        item_url,
      };
      gtag({
        event: "more_to_love_click",
        eventID: getEventId(),
        ecommerce: {
          item,
        },
      });
    });
  });
};

const trackSearch = (results) => {
  const items = results.map((product) => ({
    product_id: product.id,
    product_name: product.mappings.core.name,
    product_price: product.mappings.core.price,
    product_sku: product.mappings.core.sku,
  }));
  gtag({
    event: "view_search_suggestions",
    eventID: getEventId(),
    ecommerce: {
      items,
    },
  });
};

const trackSearchSuggestionsClick = (product) => {
  const item = {
    product_id: product.id,
    product_name: product.mappings.core.name,
    product_price: product.mappings.core.price,
    product_sku: product.mappings.core.sku,
  };

  gtag({
    event: "search_suggestion_click",
    eventID: getEventId(),
    ecommerce: {
      item,
    },
  });
};

const trackPopularSearchesClick = (term) => {
  gtag({
    event: "popular_searches_click",
    eventID: getEventId(),
    term,
  });
};

const trackSeeMoreClick = (term) => {
  gtag({
    event: "search_see_more_click",
    eventID: getEventId(),
    term,
  });
};

const trackOrderView = (orderItems, expectedDelivery) => {
  const items = orderItems.map((item) => {
    const mtoProperty = item.properties?.find(
      (prop) => prop.name === "_MADE-TO-ORDER",
    );

    return {
      item_id: item.product_id,
      variant_id: item.variant_id,
      item_name: item.title,
      sku: item.sku,
      price: item.price,
      ...(mtoProperty && {
        promised_by_date: mtoProperty.value,
        expected_delivery: expectedDelivery || mtoProperty.value,
      }),
    };
  });

  gtag({
    event: "tracking_page_view",
    eventID: getEventId(),
    ecommerce: {
      items,
    },
  });
};

const trackBridePhoneNaClick = (value) => {
  const state = value ? "checked" : "unchecked";
  gtag({
    event: "bride_form_na_click",
    eventData: {
      state, // checked / unchecked
    },
  });
};

/* eslint-enable no-unused-vars */
